import { useEffect } from 'react';

/** React equivalent of Blazor's `<PageTitle>` component. */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
